import { parseIdFilter, parseInclusionFilter } from "../../../handlers/filter";
/**
 * Converts segment filters to URL query parameters.
 * @param filters - The filters to convert
 * @returns Query string with leading '?' (always includes fetchPreferred=true)
 */
export const toQueryParams = (filters) => {
    const idsFromFilter = parseIdFilter(filters);
    const statusFromFilter = parseInclusionFilter(filters, "status", ["number"]);
    const includeLineItemsCount = filters?.fields?.includes("lineItemsCount");
    const formattedFilters = ["fetchPreferred=true"];
    if (includeLineItemsCount) {
        formattedFilters.push(`withlineitemscount=true`);
    }
    if (idsFromFilter.size > 0) {
        formattedFilters.push(`id=${[...idsFromFilter].join(",")}`);
    }
    if (statusFromFilter.size > 0) {
        formattedFilters.push(`status=${[...statusFromFilter].join(",")}`);
    }
    return `?${formattedFilters.join("&")}`;
};
//# sourceMappingURL=filters.js.map